import CartTools from './CartTools';
import SearchTools from './SearchTools';
import UserTools from './UserTools';

type ToolsNavigationProps = {};

const ToolsNavigation = ({}: ToolsNavigationProps) => {
  return (
    <nav className="tools-navigation p-7 px-5 md:p-7">
      <ul className="flex flex-row items-center justify-between md:gap-15 gap-10">
        <li>
          <SearchTools />
        </li>
        <li>
          <CartTools />
        </li>
        <li>
          <UserTools />
        </li>
      </ul>
    </nav>
  );
};

export default ToolsNavigation;
